import { render, staticRenderFns } from "./member-interest-setting.vue?vue&type=template&id=92dcbf80&scoped=true&"
import script from "./member-interest-setting.vue?vue&type=script&lang=js&"
export * from "./member-interest-setting.vue?vue&type=script&lang=js&"
import style0 from "./member-interest-setting.vue?vue&type=style&index=0&id=92dcbf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dcbf80",
  null
  
)

export default component.exports